import { mutation } from 'services/graphql';
import { gql } from '@apollo/client';

export const shareSurfaceWithUsersMutation = gql`
  mutation shareSurfaceWithUsers($input: ShareSurfaceWithUsersInput!) {
    shareSurfaceWithUsers(input: $input) {
      error
      success
    }
  }
`;

export default mutation(shareSurfaceWithUsersMutation);
